import { useCallback } from 'react';
import { Panel } from '@bigcommerce/big-design';
import AddressList from '../../../AddressList';
import './CustomerInfoSection.css';
import {
	BillingAddressForm,
	ContactDetailsForm,
	MultipleImageUpload,
	OrderDetailsForm,
	ShippingAddressForm,
} from './Forms';

export function CustomerInfoSection({ customer, setCustomer }) {
	const getCustomerValue = (name) => customer?.[name] ?? '';

	const setCustomerProperty = useCallback(
		(name, value) =>
			setCustomer((currentCustomer) => ({
				...currentCustomer,
				[name]: value,
			})),
		[setCustomer],
	);

	function setCustomerInformation(name, value) {
		const customerCopy = { ...customer }; // get a copy of the current customer
		customerCopy[name] = value;
		setCustomer({ ...customerCopy });
	}

	const customerHasSavedAddresses = customer.id && customer.address_count > 0;

	return (
		<Panel marginTop="xxxLarge">
			<div className="customer-info-container">
				<ContactDetailsForm
					getCustomerValue={getCustomerValue}
					setCustomerInformation={setCustomerInformation}
				/>
				{customerHasSavedAddresses && (
					<AddressList
						customer={customer}
						setCustomer={setCustomer}
					/>
				)}
				<ShippingAddressForm
					customer={customer}
					setCustomer={setCustomer}
				/>
				<OrderDetailsForm
					customer={customer}
					setCustomerInformation={setCustomerProperty}
				/>
				<BillingAddressForm
					customer={customer}
					setCustomer={setCustomer}
				/>
				<MultipleImageUpload
					customer={customer}
					setCustomerInformation={setCustomerProperty}
				/>
			</div>
		</Panel>
	);
}
